import React, {Component} from 'react';
import {translate} from 'react-i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as _ from 'lodash';

class ProfileWrapperView extends Component {
  render() {
    const {title, children, toast, onToastClose, onClose, t} = this.props;
    return (<div className='profile'>
      <div className="app__wrapper app__wrapper--relative">
        <div className="profile__title">
          {onClose &&
            <button className="return-button text-page__return-btn" onClick={onClose}>{t('back')}</button>
          }
          {title}
        </div>
        {!_.isEmpty(toast) && <div className={classNames('profile__toast', {
          'profile__toast--success': toast.type === 'success',
          'profile__toast--error': toast.type === 'error',
          'profile__toast--warning': toast.type === 'warning',
        })}>
          {t(toast.message)}
          {onToastClose && <span className="profile__toast-close" onClick={onToastClose}>
          </span>}
        </div>}
        <div className="profile__form">
          {children}
        </div>
      </div>
    </div>);
  }
}

ProfileWrapperView.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func,
  toast: PropTypes.object,
  onToastClose: PropTypes.func
};

export default translate('translations')(ProfileWrapperView);


// WEBPACK FOOTER //
// ./src/components/Customer/ProfileWrapperView.js